module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';
	require('script!jquery.nicescroll/jquery.nicescroll');
	require('script!slick-carousel/slick/slick');
	require('slick-carousel/slick/slick.css');
	require('../../../../common/frame/widget/promo/registration')(fox);
	require('../../../../common/frame/widget/login/member')(fox);
	require('../../promo/widget/grid/list/widgets')(fox);
	require('../../../../common/frame/widget/sidebarSlider')(fox);
	require('../../common/widget/anchorNavigator')(fox);
	
	require('../../promo/widget/promo/studios')(fox);

	require('fox-dynamic-injection!fox-template-loader!../../promo/templates/popup/registrationError.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../../../common/frame/templates/promo/login.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../promo/templates/sitepage/promo/registration.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../promo/templates/sitepage/promo/socialButtons.tpl')(fox);
	require('fox-dynamic-injection!fox-template-loader!../../promo/templates/sitepage/studios.tpl')(fox);

	require('../../../../../common-components/CCPA/templates/mc/doc.a.tpl')(fox);
	require('../../../../../common-components/CCPA/templates/mc.a.tpl')(fox);
	

	require('../css/stylus/_layout.styl');
	require('../css/stylus/_pricing.styl');
	require('../css/stylus/_pages.styl');
	require('../css/stylus/_socicon.styl');
	require('../css/stylus/_events.styl');
	require('../css/stylus/_fontFaces.styl');

	require('../components/login-wizard')(fox);
	require('../components/ccpa')(fox);
	require('../../../../common/components/mobile')(fox); 
	require('../../../../common/components/consent')(fox);

	require('GDPR')(fox);
	require('GDPR-popups')(fox);
	require('common-widgets/PopupCommon')(fox);
	require('../../../../common/components/GDPR-popups')(fox);
	require('../../../../../common-components/CCPA/widget/page')(fox);
	require('../../../../../common-components/CCPA/widget/form')(fox);
	require('../../../../common/components/sapi')(fox);

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./dependencies/dependencies.js
// module id = 526
// module chunks = 2